// /grants: the three IMDA InvoiceNow grants (each term sourced), the Productivity Solutions Grant, and the FAQ answers
// people look for alongside them. The free-of-charge package stays on /free-software.
import { Claims } from '../Cite'
import { faq, grants, psg, sources, urls } from '../data'
import { GrantCard } from '../GrantCard'
import { T, useT } from '../i18n'
import { Deferred, lazyComponent } from '../lazy'
import { PageHead, Related } from '../shell'
import { bp, eyebrow, ext, sectionDark, wrapPad } from '../ui'

const FaqList = lazyComponent<{ items: typeof faq }>(() => import('./FaqList'), { idle: true })

/** FAQ entries shown under the grants, in this order (their answers are also on /faq). */
export const GRANT_FAQ = ['is-it-free', 'software-ready', 'access-point']
/** The FAQ sentence that names all three grants: quoted on its own as the page's short answer. */
const summary = faq.find(f => f.id === 'is-it-free')!.claims.find(c => c.sourceUrl === sources.imdaGrants.url)!

export default function GrantsPage() {
  const { t } = useT()
  const items = GRANT_FAQ.map(id => faq.find(f => f.id === id)!).filter(Boolean)
  return (
    <main>
      <PageHead path="/grants" slug="grants" />
      <section id="grants" style={sectionDark}>
        <div style={{ ...wrapPad, display: 'flex', flexDirection: 'column', gap: 'var(--gap)' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 860 }}>
            <h2 style={{ margin: 0, fontSize: 'clamp(24px,3vw,34px)', fontWeight: 500, letterSpacing: '-0.02em', lineHeight: 1.15 }}>{t('grants.answerTitle')}</h2>
            <p style={{ margin: 0, fontSize: 17, lineHeight: 1.6, color: '#d9e8e2', textWrap: 'pretty' }}><Claims claims={[summary, psg]} /></p>
            <div className="btn-stack" style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a href={urls.imdaGrants} {...ext} {...bp(true)}>{t('grants.imda')} →</a>
              <a href={urls.grantsInfographic} {...ext} {...bp(false)}>{t('grants.infographic')} →</a>
              <a href={urls.grantFaq} {...ext} {...bp(false)}>{t('grants.faqLink')} →</a>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))', gap: 16 }}>
            {grants.filter(g => g.id !== 'foc').map(g => <GrantCard key={g.id} g={g} />)}
          </div>
          <p style={{ margin: 0, fontSize: 13, color: '#9dbdb2' }}>
            <T k="grants.footnote" values={{ grantsLabel: sources.imdaGrants.label }} components={{ grants: <a href={urls.imdaGrants} {...ext} lang="en" /> }} />
          </p>
          <div id="grant-faq" style={{ display: 'flex', flexDirection: 'column', gap: 20, scrollMarginTop: 96 }}>
            <h2 style={{ ...eyebrow(), margin: 0, fontWeight: 400 }}>{t('grants.faqHeading')}</h2>
            <Deferred><FaqList items={items} /></Deferred>
          </div>
        </div>
      </section>
      <Related paths={['/free-software', '/when', '/faq']} />
    </main>
  )
}
